import Row from '@components/Row';
import Text from '@components/Text';
import TextUnderline from '@components/TextUnderline';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import LocationFill from '@icons/LocationFill';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';
import { useTranslation } from 'react-i18next';

function Shop() {
    const { shopName } = useCalculatedRequest();
    const { t } = useTranslation('order');
    return (
        <Container >
            <LocationFill color={colors.gray6}
                style={{ marginRight: 4 }}/>
            <TextUnderline>
                <Text size='lg' fontWeight='bold'>{shopName}</Text>
            </TextUnderline>
            <Text size='lg'>{t('shop.orderFrom')}</Text>
        </Container>
    );
}

const Container = styled(Row)`
    padding: 12px 16px;
    margin-top: 12px;
`;

export default Shop;
